module.exports = __webpack_public_path__ + "img/phone-l.45f1b2e.png";